"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouteForLandingPage = void 0;
const type_graphql_1 = require("type-graphql");
const LocationForLandingPage_1 = require("./LocationForLandingPage");
let RouteForLandingPage = class RouteForLandingPage {
    _id;
    originLocation;
    destinationLocation;
    originLocationMachineNameWithCountry;
    destinationLocationMachineNameWithCountry;
};
exports.RouteForLandingPage = RouteForLandingPage;
__decorate([
    (0, type_graphql_1.Field)(),
    __metadata("design:type", String)
], RouteForLandingPage.prototype, "_id", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => LocationForLandingPage_1.LocationForLandingPage),
    __metadata("design:type", LocationForLandingPage_1.LocationForLandingPage)
], RouteForLandingPage.prototype, "originLocation", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => LocationForLandingPage_1.LocationForLandingPage),
    __metadata("design:type", LocationForLandingPage_1.LocationForLandingPage)
], RouteForLandingPage.prototype, "destinationLocation", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => String),
    __metadata("design:type", String)
], RouteForLandingPage.prototype, "originLocationMachineNameWithCountry", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => String),
    __metadata("design:type", String)
], RouteForLandingPage.prototype, "destinationLocationMachineNameWithCountry", void 0);
exports.RouteForLandingPage = RouteForLandingPage = __decorate([
    (0, type_graphql_1.ObjectType)("RouteForLandingPage")
], RouteForLandingPage);
//# sourceMappingURL=RouteForLandingPage.js.map